"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentInjectionManager = void 0;
var component_injection_manager_1 = require("./component-injection-manager");
Object.defineProperty(exports, "ComponentInjectionManager", { enumerable: true, get: function () { return component_injection_manager_1.ComponentInjectionManager; } });
